import { createPhotoPinSvg, POIPinSize } from './svgMarkerComponents';

export const imageNamePrefix = `poi-pin-photo`;
export const getPOIPhotoName = (id: number, size: POIPinSize) => `${imageNamePrefix}-${id}-${size}`;
const createPOIPhotoPinSvg = (id: number, imageUrl: string, size: POIPinSize) => createPhotoPinSvg(getPOIPhotoName(id, size), id, imageUrl, size);

export default createPOIPhotoPinSvg;
